// extracted by mini-css-extract-plugin
export default {"tags-feed-admin-right-side":"TagsFeedAdminRightSide_tags-feed-admin-right-side__O5Vo8"};